export const getCommerceSearchInitialState = () => ({
    error: null,
    isLoading: false,
    requestId: '',
    responseId: '',
    products: [],
    results: [],
    facets: [],
    queryExecuted: '',
});
